import { intervalToDuration, isBefore } from 'date-fns';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useGetRemainingTime = () => {
  const { t } = useTranslation();

  return useCallback(
    ({ targetDate }: { targetDate: Date }) => {
      const now = new Date();
      const duration = intervalToDuration({ end: targetDate, start: now });
      const months = (duration.years ?? 0) * 12 + (duration.months ?? 0);

      if (isBefore(targetDate, now)) {
        return [];
      }

      const timeUnits = [
        { label: t('months', { count: months }), value: months },
        { label: t('days', { count: duration.days ?? 0 }), value: duration.days ?? 0 },
        { label: t('hours', { count: duration.hours ?? 0 }), value: duration.hours ?? 0 },
        { label: t('mins', { count: duration.minutes ?? 0 }), value: duration.minutes ?? 0 },
        { label: t('secs', { count: duration.seconds ?? 0 }), value: duration.seconds ?? 0 },
      ];

      const firstNonZeroIndex = timeUnits.findIndex((timeUnit) => timeUnit.value !== 0);
      return timeUnits.slice(firstNonZeroIndex, firstNonZeroIndex + 4);
    },
    [t],
  );
};
